// React
import React from "react";

// External libraries
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/sharp-solid-svg-icons";

// CSS
import "./forms.css";

function FormError(props) {
    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    // todo - add help link
    return (
        <div className="eone-ui-form-error-container">
            <label className="eone-ui-form-error">
                <FontAwesomeIcon icon={props.Icon || faCircleExclamation} />
                <span data-testid={props.DataTestId}>{props.Message}</span>
            </label>
        </div>
    );
}

export {FormError};